import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import Button from '../components/common/Button';
import { MAX_LOAN_LIMIT } from '../utils/constants';
import useAuthStore from '../stores/authStore';

const LoanLimits = () => {
  const navigate = useNavigate();
  const { profile, isAuthenticated } = useAuthStore();

  useEffect(() => {
    // Redirect if not authenticated or profile not complete
    if (!isAuthenticated || !profile?.profileCompleted) {
      navigate('/profile-step-1');
    }
  }, [isAuthenticated, profile, navigate]);

  const handleContinue = () => {
    navigate('/service-fee-selection');
  };

  const handleBack = () => {
    navigate('/dashboard');
  };

  return (
    <div className="page-container">
      <div className="form-container">
        <div className="text-center mb-8">
          <div className="w-20 h-20 bg-success-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-10 h-10 text-success-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <h1 className="text-2xl font-bold text-gray-900 mb-2">
            Profile Complete!
          </h1>
          <p className="text-gray-600">
            Your maximum loan limit has been calculated
          </p>
        </div>

        <div className="bg-gradient-to-r from-primary-500 to-primary-600 rounded-2xl p-8 text-white text-center mb-8">
          <h2 className="text-lg font-medium mb-2">
            Your Maximum Loan Limit
          </h2>
          <p className="text-4xl font-bold mb-2">
            KES {MAX_LOAN_LIMIT.toLocaleString()}
          </p>
          <p className="text-primary-100 text-sm">
            Based on your profile information
          </p>
        </div>

        {/* Profile Summary */}
        {/*<div className="bg-gray-50 rounded-xl p-6 mb-8">
          <h3 className="font-semibold text-gray-900 mb-4">Profile Summary</h3>
          <div className="grid grid-cols-2 gap-4 text-sm">
            <div>
              <span className="text-gray-500">Name:</span>
              <p className="font-medium">{profile?.fullName}</p>
            </div>
            <div>
              <span className="text-gray-500">County:</span>
              <p className="font-medium">{profile?.county}</p>
            </div>
            <div>
              <span className="text-gray-500">Employment:</span>
              <p className="font-medium">{profile?.employmentStatus}</p>
            </div>
            <div>
              <span className="text-gray-500">Monthly Income:</span>
              <p className="font-medium">KES {profile?.monthlyIncome?.toLocaleString()}</p>
            </div>
          </div>
        </div>*/}

        <div className="bg-blue-50 rounded-xl p-6 mb-8">
          <div className="flex items-start">
            <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center mr-3 mt-0.5">
              <svg className="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <div>
              <h3 className="font-semibold text-blue-900 mb-1">Important Information</h3>
              <ul className="text-blue-800 text-sm space-y-1">
                <li>• You can apply for any amount up to your limit</li>
                <li>• A service fee is required for loan processing</li>
                <li>• Loan approval takes up to 48 hours</li>
                <li>• Funds are sent directly to your M-Pesa</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="flex gap-4">
          <Button
            type="button"
            variant="outline"
            size="lg"
            className="flex-1"
            onClick={handleBack}
          >
            Back to Dashboard
          </Button>
          <Button
            type="button"
            size="lg"
            className="flex-1"
            onClick={handleContinue}
          >
            Apply for Loan
          </Button>
        </div>
      </div>
    </div>
  );
};

export default LoanLimits;